import { gql } from '@apollo/client';

const PING_AI_API = gql`
  query pingAiApi($profileId: ID!, $tab: String) {
    pingAiApi(profileId: $profileId, tab: $tab)
  }
`;

export default PING_AI_API;
